<script lang="ts">
    import { closeModal } from 'svelte-modals';
    import { _ } from 'svelte-i18n';

    import ButtonBack from '../ButtonBack.svelte';
    import { debug } from '../../../stores/store';
    import { clickOutside } from '../../utilities/clickOutside';

    export let isOpen: boolean = false;
    export let header: string = 'An error occurred';
    export let message: string = 'errors_while_loading';
    export let error: string = '';

    export let onClick: () => void = () => {};

    function clickOk() {
        closeModal();
        onClick();
    }
</script>

{#if isOpen}
    <div role="dialog" class="modal" use:clickOutside on:click_outside={clickOk}>
        <div class="contents">
            {#if $debug}
                <div class="error-details" style="opacity: 0.9; margin-top: 10px;">
                    ERROR:
                    <pre>{error}</pre>
                    {message}
                </div>
            {:else}
                <h3 style="text-align: center;">{$_(header)}</h3>
                <div style="text-align: center;">{$_(message)}</div>
            {/if}

            <div class="actions">
                <ButtonBack text={$_('OK')} showIcon={false} on:click={clickOk} />
            </div>
        </div>
    </div>
{/if}

<style>
    .modal {
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1002;

        /* allow click-through to backdrop */
        pointer-events: none;
    }

    .contents {
        min-width: 390px;
        max-width: 490px;
        border-radius: 6px;
        background: white;
        /*background-color: #d45659;*/
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        pointer-events: auto;
        font-size: 14px;
        padding: 30px;
        border: 3px solid #d45659;
        row-gap: 15px;
        /*border: 3px solid ;*/
        box-shadow:
            0 0 0 10px #d93b4d44,
            0 4px 8px rgba(0, 0, 0, 0.2);
    }

    .actions {
        margin-top: 32px;
        display: flex;
        justify-content: center;
        column-gap: 10px;
    }
</style>
